import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TOOLTIP_DELAY } from "../../../../common/Constants";
import { CellTmpl, DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD, reactFormatter } from "../../../../common/Table";
import { useDeleteVertical, useGetCompanies, useGetVerticals } from "../../../../../backend/masters";
import VerticalDetails from "./VerticalDetails";
import { useExportVerticals } from "../../../../../backend/exports";
import BaseList from "../../../../common/BaseList";
import AddEditVertical from "./AddEditVertical";
import { VerticalSchema } from "../../../../../models/vertical";

const VERTICALS_DEFAULT_PAYLOAD = {
    sorts: ['updated_at desc'],
    includes: ['company'],
    include: {
      company: {
        only: ['id','name']
      }
    }
  }

function ManageVerticals() {
    const [t] = useState(new Date().getTime());
    const { companies } = useGetCompanies({ ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true }, t });
    const [breadcrumb] = useState([
        { id: 'home', label: 'Home', path: '/' },
        { id: 'companies', label: 'Companies', path: '/companies/list' },
        { id: 'verticals', label: 'Verticals' },
    ]);

    function CompanyTmpl({ cell }: any) {
        const row = cell.getData();
        const value = ((row || {}).company || {}).name;
        return (
            <>
                {
                    !!value &&
                    <div className="d-flex align-items-center h-100 w-auto">
                        <OverlayTrigger overlay={<Tooltip>{value}</Tooltip>} rootClose={true}
                            placement="bottom" delay={{ show: TOOLTIP_DELAY } as any}>
                            <div className="ellipse two-lines">{value}</div>
                        </OverlayTrigger>
                    </div>
                }
            </>
        )
    }
    const columns = [
        { title: "Company", field: "company_id", formatter: reactFormatter(<CompanyTmpl />) },
        { title: "Code", field: "short_code", formatter: reactFormatter(<CellTmpl />) },
        { title: "Name", field: "name", formatter: reactFormatter(<CellTmpl />) },
        { title: "Description", field: "description", widthGrow: 2, formatter: reactFormatter(<CellTmpl />) }
    ]

    const filterConfig = [
        {
            label: 'Company',
            name: 'company_id_eq',
            options: (companies || []).map((x: any) => {
                return { value: x.id, label: x.name };
            })
        }
    ]

    return (
        <BaseList
            fetchData={useGetVerticals}
            exportData={useExportVerticals}
            deleteData={useDeleteVertical}
            nameAttribute={'name'}
            columns={columns}
            DetailView={VerticalDetails}
            FormView={AddEditVertical}
            modelSchema={VerticalSchema}
            initialSort={['name asc']}
            breadcrumb={breadcrumb}
            initialPayload={VERTICALS_DEFAULT_PAYLOAD}
            filterConfig={filterConfig}
            title="Companies - Verticals"
        />
    )
}

export default ManageVerticals;
